import AddIcon from '@mui/icons-material/Add';
import { Button, Divider, Stack, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import { cloneDeep, concat, get, set } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import MUIAccordionComponent from 'src/components/ui-component/mui-accordion/MUIAccordionComponent';
import { useApplication } from 'src/context/ApplicationContext';
import { ALS_ERLEDIGT_MARKIEREN_LABEL, EMOB_INVEST_IMAGE_UPLOAD_FIELD_PROPS, FORM_FIELDS_TYPES, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue, NonRequired } from 'src/lib/validation/ValidationTypes';
import { addIndexesToPath, checkReadOnlyInUeberarbeitung, isTrue } from 'src/utils/helper';
import PruefAssistenz from '../../../../../../antrag-components/PruefAssistenz';
import ApplicationHeading from '../../../../../../application-heading/ApplicationHeading';
import { checkIfPruefAssitenzNeedsToValidate } from '../../../../../../application-helper-function/AppHelperfunctions';

// import schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = Schema.attributes;

const TechnischespezifikationElektrofahrzeugAntragEmobInvest: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, saveApplication, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);

	const handleAddSpezifikation = () => {
		let appCopy = cloneDeep(application);
		const key = addIndexesToPath(
			P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Spezifikation_Des_Zu_Beschaffenden_E_Fahrzeugs.schema.attributes
				.E_45_Nutzfahrzeug.path,
			[
				`${get(appCopy, P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Spezifikation_Des_Zu_Beschaffenden_E_Fahrzeugs.path, []).length}`,
			],
			['Spezifikation_Des_Zu_Beschaffenden_E_Fahrzeugs'],
		);
		set(appCopy, key, null);
		saveApplication(false, appCopy);
	};
	const handleDeleteSpezifikation = (index: number) => {
		try {
			let appCopy = cloneDeep(application);
			const allspezifikation = get(
				appCopy,
				P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Spezifikation_Des_Zu_Beschaffenden_E_Fahrzeugs.path,
				[],
			);
			set(
				appCopy,
				P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Spezifikation_Des_Zu_Beschaffenden_E_Fahrzeugs.path,
				allspezifikation.filter((_: any, i: number) => i !== index),
			);
			saveApplication(false, appCopy);
		} catch (err: any) {
			console.error('ERROR: Deleting Spezifikation zu Elektrofahrzeig ', err);
		}
	};

	return (
		<>
			<ApplicationHeading title='Technische Spezifikationen Elektrofahrzeug' description={PLATZHALTER_TEXT} />

			<PruefAssistenz
				statusPath={
					P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0097856355_ahrzeug_Pruefung_Pruefstatus.path
				}
				hinweisPath={
					P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0166927874_nweis_Fuer_Den_Antragsteller.path
				}
				ueberarbeitetAmPath={
					P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0165294973_ug_Pruefung_Ueberarbeitet_Am.path
				}
				erledigtPath={
					P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0211431332_rofahrzeug_Pruefung_Erledigt.path
				}
				formStruc={formStrucPruefAssistenz()}
			/>

			<Typography variant='h6'>Spezifikation des zu beschaffenden E-Fahrzeugs </Typography>
			<CreateForm
				formStruc={formStrucBedingung()}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={updatedReadOnly}
			/>
			<Divider />

			{(
				isTrue(
					get(
						application,
						P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0146903038_ofahrzeuge_Investiert_Werden
							.path,
					),
				)
			) ?
				<>
					<Stack direction={'row'} sx={{ mt: '1rem' }} justifyContent={'space-between'} alignItems={'flex-end'}>
						<Typography>Spezifikation des zu beschaffenden E-Fahrzeugs</Typography>
						<Button endIcon={<AddIcon />} onClick={handleAddSpezifikation}>
							Spezifikation hinzufügen
						</Button>
					</Stack>
					{get(
						application,
						P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Spezifikation_Des_Zu_Beschaffenden_E_Fahrzeugs.path,
						[],
					).map((_ele: any, i: number) => {
						return (
							<>
								<MUIAccordionComponent
									summaryTitle={`Spezifikation des zu beschaffenden E-Fahrzeugs ${i + 1}`}
									onDelete={() => handleDeleteSpezifikation(i)}
									showDeleteButton={!updatedReadOnly}
								>
									<Grid2 spacing={6} container>
										<Grid2 sm={6}>
											<CreateForm
												formStruc={mapSpezifikation(formStrucSpezifikationSpalte1(), i)}
												formValues={application}
												updateFormValuesFunc={setApplicationProperty}
												readOnly={updatedReadOnly}
											/>
										</Grid2>
										<Grid2 sm={6}>
											{' '}
											<CreateForm
												formStruc={mapSpezifikation(formStrucSpezifikationSpalte2(), i)}
												formValues={application}
												updateFormValuesFunc={setApplicationProperty}
												readOnly={updatedReadOnly}
											/>
										</Grid2>
									</Grid2>
								</MUIAccordionComponent>
							</>
						);
					})}

					<CreateForm
						formStruc={formStrucErlauterungen()}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={updatedReadOnly}
					/>
				</>
			:	null}
		</>
	);
};
export default TechnischespezifikationElektrofahrzeugAntragEmobInvest;

const formStrucPruefAssistenz = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0211431332_rofahrzeug_Pruefung_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
	return struc;
};
const formStrucBedingung = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0146903038_ofahrzeuge_Investiert_Werden],
		},
	];
	return struc;
};

const formStrucSpezifikationSpalte1 = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Spezifikation_Des_Zu_Beschaffenden_E_Fahrzeugs.schema.attributes
					.E_45_Nutzfahrzeug,
				P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Spezifikation_Des_Zu_Beschaffenden_E_Fahrzeugs.schema.attributes
					.E_45_Sonderfahrzeug,
			],
			userProps: { columnToDivide: 2 },
		},
		{
			fields: [
				P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Spezifikation_Des_Zu_Beschaffenden_E_Fahrzeugs.schema.attributes
					.Sonstige_Fahrzeugklasse,
				P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Spezifikation_Des_Zu_Beschaffenden_E_Fahrzeugs.schema.attributes
					.Moegliche_Hersteller,
			],
			userProps: { columnToDivide: 2 },
		},
		{
			fields: [
				P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Spezifikation_Des_Zu_Beschaffenden_E_Fahrzeugs.schema.attributes
					.Typenbezeichnung,
				P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Spezifikation_Des_Zu_Beschaffenden_E_Fahrzeugs.schema.attributes
					.Elektrischer_Antrieb_Ueber,
			],
			userProps: { columnToDivide: 2 },
		},
		{
			fields: [
				P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Spezifikation_Des_Zu_Beschaffenden_E_Fahrzeugs.schema.attributes
					.Anzahl_Sitzplaetze,
			],
			userProps: { columnToDivide: 2 },
		},
		{
			fields: [
				P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Spezifikation_Des_Zu_Beschaffenden_E_Fahrzeugs.schema.attributes
					.Zulassung_Oeffentlicher_Strassenverkehr,
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};
const formStrucSpezifikationSpalte2 = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Spezifikation_Des_Zu_Beschaffenden_E_Fahrzeugs.schema.attributes
					.Gesamtgewicht,
				P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Spezifikation_Des_Zu_Beschaffenden_E_Fahrzeugs.schema.attributes
					.Batteriekapazitaet_40_k_Wh_41,
			],
			userProps: { columnToDivide: 2 },
		},
		{
			fields: [
				P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Spezifikation_Des_Zu_Beschaffenden_E_Fahrzeugs.schema.attributes
					.Max_46_Ladeleistung_40_k_W_41,
				{
					...P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Spezifikation_Des_Zu_Beschaffenden_E_Fahrzeugs.schema.attributes
						.Brennstoffzelle_40_k_W_4142,
					validation: [{ validateFunction: NonRequired }],
				},
			],
			userProps: { columnToDivide: 2 },
		},
		{
			fields: [
				{
					...P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Spezifikation_Des_Zu_Beschaffenden_E_Fahrzeugs.schema.attributes
						.H_245_Speicher_40_kg_41,
					validation: [{ validateFunction: NonRequired }],
				},
				P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Spezifikation_Des_Zu_Beschaffenden_E_Fahrzeugs.schema.attributes
					.Reichweite_40_km_41,
			],
			userProps: { columnToDivide: 2 },
		},
	];
	return struc;
};

const formStrucErlauterungen = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0237726141_he_Fahrleistungen_Pro_Jahrkm],
			userProps: { direction: 'column', columnToDivide: 2 },
		},
		{
			fields: [
				P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0179814805_eschaffende_Elektrofahrzeuge,
				P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0123191733_gruppen_Der_Elektrofahrzeuge,
				P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0064233173_nsbedarf_In_Elektrofahrzeuge,
				{
					...P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0112109858_ionen_Elektrofahrzeug_Bilder,
					type: FORM_FIELDS_TYPES.editableTable,
					...EMOB_INVEST_IMAGE_UPLOAD_FIELD_PROPS,
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

const mapSpezifikation = (formStruc: FormStrucItem[], i: number) => {
	let result = formStruc.map((row) => {
		return {
			...row,
			fields: get(row, 'fields', []).map((value: any) => {
				return {
					...value,
					path: addIndexesToPath(get(value, 'path'), [`${i}`], ['Spezifikation_Des_Zu_Beschaffenden_E_Fahrzeugs']),
				};
			}),
		};
	});
	return result;
};
export const getFormStrucTechnischespezifikationElektrofahrzeugAntragEmobInvest = (application: any) => {
	const formStrucSpzificationLength = get(
		application,
		P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Spezifikation_Des_Zu_Beschaffenden_E_Fahrzeugs.path,
		[],
	).length;
	let formStrucSpezifikationWithIndex: FormStrucItem[] = [];

	for (let i = 0; i < formStrucSpzificationLength; i++) {
		formStrucSpezifikationWithIndex = concat(
			formStrucSpezifikationWithIndex,
			mapSpezifikation(formStrucSpezifikationSpalte1(), i),
			mapSpezifikation(formStrucSpezifikationSpalte2(), i),
		);
	}
	const isSollSrucTrue = isTrue(
		get(
			application,
			P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0146903038_ofahrzeuge_Investiert_Werden.path,
		),
	);
	if (isSollSrucTrue) {
		if (
			checkIfPruefAssitenzNeedsToValidate(
				application,
				P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0097856355_ahrzeug_Pruefung_Pruefstatus.path,
				P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0211431332_rofahrzeug_Pruefung_Erledigt.path,
			)
		)
			return concat(formStrucPruefAssistenz(), formStrucSpezifikationWithIndex, formStrucErlauterungen());
		return concat(formStrucSpezifikationWithIndex, formStrucErlauterungen());
	}
};
